module.exports = __webpack_public_path__ + "img/1.97095292.jpg";